var Backbone = require('backbone'),
    Zone = require('../../positionalTextModels/textAreaModels/zone');

module.exports = Backbone.Collection.extend({

    model: Zone

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgPositionalTextModel/zones.js
 ** module id = 347
 ** module chunks = 0
 **/